import { render } from "./TbHeader.vue?vue&type=template&id=73803e71&scoped=true"
import script from "./TbHeader.vue?vue&type=script&lang=js"
export * from "./TbHeader.vue?vue&type=script&lang=js"

import "./TbHeader.vue?vue&type=style&index=0&id=73803e71&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73803e71"]])

export default __exports__